import calls from '@/backend/api-calls'

const state = {
  announcements: [],
  loading: false
}

const getters = {
}

const actions = {
  getAnnouncements: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.announcements.get(parameters).then(resp => {
        commit("setAnnouncements", resp.data.results);
        commit("setLoading", false);
        resolve(resp);
      }).catch(err => reject(err));
    })
  },
  addAnnouncement: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.announcements.post(data).then(resp => {
        commit("insertAnnouncement", resp.data);
        commit("app/setNotification", {
          type: 'success',
          status: true,
          message: 'Announcement successfully added'
        }, { root: true });
        resolve(resp);
      }).catch(err => reject(err));
    })
  },
  deleteAnnouncement: ({commit}, announcementId) => {
    return new Promise((resolve, reject) => {
      calls.announcement.delete(announcementId).then(resp => {
        commit("removeAnnouncement", announcementId);
        resolve(resp);
      }).catch(err => reject(err));
    })
  },
  saveAnnouncementImage: ({commit}, {announcementId, data}) => {
    return new Promise((resolve, reject) => {
      calls.announcement.addImage(announcementId, data).then(resp => {
        commit("insertUpdatedAnnouncement", resp.data);
        resolve(resp);
      }).catch(err => reject(err));
    })
  },
  updateAnnouncement: ({commit}, {announcementId, data}) => {
    return new Promise((resolve, reject) => {
      calls.announcement.put(announcementId, data).then(resp => {
        commit("insertUpdatedAnnouncement", resp.data);
        commit("app/setNotification", {
          type: 'success',
          status: true,
          message: 'Announcement successfully updated'
        }, { root: true });
        resolve(resp);
      }).catch(err => reject(err));
    })
  }
}

const mutations = {
  setLoading: (state, data) => {
    state.loading = data;
  },
  setAnnouncements: (state, data) => {
    state.announcements = data;
  },
  insertAnnouncement: (state, data) => {
    state.announcements.unshift(data);
  },
  removeAnnouncement: (state, announcementId) => {
    state.announcements.forEach((announcement, i) => {
      if (announcement.id == announcementId) {
        state.announcements.splice(i, 1);
      }
    })
  },
  insertUpdatedAnnouncement: (state, data) => {
    state.announcements.forEach((announcement, i) => {
      if (announcement.id == data.id) {
        state.announcements.splice(i, 1, data);
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
